import styled from 'styled-components';

export const StyledBreadCrumbs = styled.div`
  .bread-crumbs {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    margin-bottom: 8.5px;
  }
`;
